import { SummaryMatchModel } from '@clsplus/cls-plus-data-models'
import { types } from 'mobx-state-tree'

const MatchesSearchMap = types.model('MatchesSearchMap', {
  filter: types.identifier,
  data: types.array(SummaryMatchModel),
})

export default MatchesSearchMap
